import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {PreviousMeetingsWidgetFetchHandler} from "./previous-meetings-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PreviousMeetingsWidgetToggleCollapsedHandler} from "./previous-meetings-widget-toggle-collapsed.handler";
import {MatchDetailsClickEventHandler} from "../../../core/handlers/match-details.click-event.handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";

export class PreviousMeetingsWidgetHandlers extends HandlerList {
  static injectables = [
    PreviousMeetingsWidgetFetchHandler,
    PreviousMeetingsWidgetToggleCollapsedHandler,
    MatchDetailsClickEventHandler,
    EntityClickEventHandler,
    TimingHandler,
    PopulateDataHandler];

  constructor(
    previousMeetingsWidgetFetchHandler: PreviousMeetingsWidgetFetchHandler,
    previousMeetingsWidgetToggleShowAllHandler: PreviousMeetingsWidgetToggleCollapsedHandler,
    matchDetailsClickEventHandler: MatchDetailsClickEventHandler,
    entityClickEventHandler: EntityClickEventHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler) {
    super();

    [
      previousMeetingsWidgetFetchHandler,
      previousMeetingsWidgetToggleShowAllHandler,
      matchDetailsClickEventHandler,
      entityClickEventHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
